import type { ShareCopy } from './types'

/**
 * Тексты шэринга. Секции `share.*` в 08_copy.md нет: сам шэринг там описан прозой в спеках
 * экранов (03 §4, 05, 06 Н·5), а подписи сообщений уже живут ключами `main.share_message`,
 * `compat.share_message` и `NATAL_SHARE_CAPTION`. Здесь — только то, чего в копи-документе
 * не было вовсе: реакции на неудачу и на публикацию в историю.
 */
export const share: ShareCopy = {
  error: 'Карточка не собралась. Попробуй ещё раз 🐾',
  story_done: 'Улетело в историю',
}
